import React from 'react';
import { Link } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';
import useParamsRouter from '../../../hooks/useParamsRouter';

const GET_CREDENTIAL_TYPE_LIST = gql`
  query GetCredentialTypeList {
    credentialTypes {
      id
      displayName
      value
      isActive @client
    }
  }
`;

export default function CredentialTypeTabs() {
  const { credentialTypeIdInt } = useParamsRouter();
  const { data: { credentialTypes = [] } = {}, loading } = useQuery(GET_CREDENTIAL_TYPE_LIST);

  if (loading) {
    return <div>Loading...</div>;
  }

  const credentialTypesActive = credentialTypes?.filter((credential) => credential.isActive);

  return (
    <div className="row">
      <ul
        className="nav h6"
        style={{
          position: 'absolute',
          bottom: '0px',
          overflow: 'hidden',
        }}
      >
        {credentialTypesActive?.map((obj) => (
          <li className="nav-item" key={obj.value}>
            <Link
              to={`/credential-type/${obj.id}/groupings/`}
              className={obj.id === credentialTypeIdInt ? 'nav-link active' : 'nav-link'}
            >
              {obj.displayName}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
